import React from "react";
import "./PaywallPopup.css";
const ContentDiv = () => {
  const Data = [
    {
      title: "The one tool in my content flow I can’t live without",
      signature: "Jordan @TradingCompared",
    },
    {
      title: "I’ve never seen such quick and easy traffic, using others content",
      signature: "Melonie @JTR-YTchannel",
    },
    {
      title: "I never thought blogging and SEO was easy until now.",
      signature: "Paul @PharmaCast",
    },
    {
      title: "The one tool in my current flow I can't live without",
      signature: "Jordan @TradingCompared",
    },
  ];
  return (
    <div className="all-boxes-container">
      {Data.map((data, index) => {
        return (
          <div className="content-container" key={index}>
            <p className="bold-text">"{data.title}"</p>
            <p className="ligther-text">{data.signature}</p>
          </div>
        );
      })}
    </div>
  );
};

export default ContentDiv;
